export function Child (parentId = null, visibleInput = true, showVat = false, vat = null) {
    this.id = new Date().getTime();
    this.name = "";
    this.quantity = 0.00;
    this.uom = "";
    this.price = 0.00;
    this.totalValue = 0.00;
    this.parentId = parentId;
    this.children = [];
    this.vat = showVat ? vat : null;
    this.visibleInput = visibleInput;
    this.isSave = false;
}